import { render, staticRenderFns } from "./position.vue?vue&type=template&id=cf00df22&scoped=true"
import script from "./position.vue?vue&type=script&lang=js"
export * from "./position.vue?vue&type=script&lang=js"
import style0 from "./position.vue?vue&type=style&index=0&id=cf00df22&prod&lang=scss&scoped=true"
import style1 from "./position.vue?vue&type=style&index=1&id=cf00df22&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cf00df22",
  null
  
)

export default component.exports